import {StyleSheet} from "aphrodite";
import * as React from "react";

import {addStyle, View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

// import {color} from "@khanacademy/wonder-blocks-tokens";
import {GuideColors} from "./guide-colors.ts";

const StyledSpan = addStyle("span");

interface Props {
    inline?: boolean;
}

/**
 * TypingIndicator renders a visual cue to indicate that the AIGuide is
 * streaming a response.
 */
const TypingIndicator = (props: Props): React.ReactElement => {
    const {inline} = props;
    const indicator = (
        <StyledSpan
            style={[styles.blink, styles.cursor]}
            aria-hidden={true}
            data-testid="guide-typing-indicator"
        >
            {" ▌"}
        </StyledSpan>
    );

    if (inline) {
        return indicator;
    }

    return (
        <View style={styles.container} testId="guide-typing-indicator">
            <View style={styles.messageBubble}>{indicator}</View>
            {/*
                The following struts are placeholders for the feedback footer
                under each incoming message 4px for the margin, 24px for the
                footer.
            */}
            <Strut size={spacing.xxxSmall_4} />
            <Strut size={spacing.large_24} />
        </View>
    );
};

const BLINK_KEY_FRAMES = {
    "50%": {
        visibility: "hidden",
    },
} as const;

const styles = StyleSheet.create({
    container: {
        alignItems: "start",
        justifyContent: "flex-start",
    },
    cursor: {
        color: GuideColors.darkPurple,
        opacity: 0.75,
    },
    blink: {
        animationDirection: "reverse",
        animationDuration: "1000ms",
        animationTimingFunction: "step-start",
        animationIterationCount: "infinite",
        // @ts-expect-error - TS2322 - Type '{ readonly "50%": { readonly visibility: "hidden"; }; }' is not assignable to type 'string'.
        animationName: [BLINK_KEY_FRAMES],
    },
    messageBubble: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: `${spacing.xSmall_8}px ${spacing.medium_16}px`,
        height: 36,
        borderRadius: 8,
        backgroundColor: GuideColors.peach,
        borderStartStartRadius: 0,
    },
});

export {TypingIndicator};
